import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Observable, map } from 'rxjs';
import { RouterModule } from '@angular/router';
import { RentalApplicationService } from '../../services/rental-application.service';

@Component({
  selector: 'app-admin-applications',
  standalone: true,
  imports: [CommonModule, RouterModule],
  templateUrl: './admin-applications.component.html'
})
export class AdminApplicationsComponent implements OnInit {

  applicationRounds$!: Observable<any[]>;

  selectedApplication: any | null = null;
  selectedRound: any | null = null;

  pageSize = 10;

  constructor(
    private applicationService: RentalApplicationService
  ) {}

  ngOnInit(): void {
    this.applicationRounds$ = this.applicationService
      .getApplicationRoundsWithApplications()
      .pipe(
        map(rounds =>
          rounds.map(round => ({
            ...round,

            // UI-only state
            expanded: round.expanded ?? false,
            page: round.page ?? 1,
            sortBy: round.sortBy ?? 'income',

            applications: [...round.applications].sort(
              (a: any, b: any) =>
                this.getTotalIncome(b) - this.getTotalIncome(a)
            )
          }))
        )
      );
  }

  /* -------------------------
     UI interactions
  --------------------------*/

  toggleRound(round: any): void {
    round.expanded = !round.expanded;
  }

  sortApplications(round: any, sortBy: 'income' | 'date'): void {
    round.sortBy = sortBy;

    round.applications.sort((a: any, b: any) => {
      if (sortBy === 'income') {
        return this.getTotalIncome(b) - this.getTotalIncome(a);
      }
      return (
        this.getCreatedAtDate(b.createdAt)?.getTime() ?? 0
      ) - (
        this.getCreatedAtDate(a.createdAt)?.getTime() ?? 0
      );
    });

    round.page = 1;
  }
  printApplication(roundId: string, applicationId: string) {
  window.open(
    `/print-application/${roundId}/${applicationId}`,
    '_blank'
  );
}


  getPagedApplications(round: any): any[] {
    const start = (round.page - 1) * this.pageSize;
    return round.applications.slice(start, start + this.pageSize);
  }

  totalPages(round: any): number {
    return Math.ceil(round.applications.length / this.pageSize);
  }

  /* -------------------------
     Modal handling
  --------------------------*/

  openApplicationDetails(round: any, app: any): void {
    this.selectedRound = round;
    this.selectedApplication = app;
    document.body.style.overflow = 'hidden';
  }

  closeModal(): void {
    this.selectedApplication = null;
    this.selectedRound = null;
    document.body.style.overflow = '';
  }

  /* -------------------------
     Approve / Reject
  --------------------------*/

  async approveApplication(roundId: string, rentalId: string, app: any): Promise<void> {
    await this.applicationService.approveApplicationInRound(
      roundId,
      rentalId,
      app.applicationId
    );

    // UI clean-up
    this.closeModal();
  }

  async rejectApplication(roundId: string,app: any): Promise<void> {
    await this.applicationService.rejectApplicationInRound(
      roundId,
      app.applicationId
    );

    // Remove rejected app from UI immediately
    this.applicationRounds$ = this.applicationRounds$.pipe(
      map(rounds =>
        rounds.map(round =>
          round.roundId !== roundId
            ? round
            : {
                ...round,
                applications: round.applications.filter(
                  (a: any) => a.applicationId !== app.applicationId
                )
              }
        )
      )
    );

    this.closeModal();
  }

  /* -------------------------
     Helpers
  --------------------------*/

  getTotalIncome(app: any): number {
    const income = Number(app.income) || 0;
    const coIncome = Number(app.coincome) || 0;
    return income + coIncome;
  }

  getCreatedAtDate(createdAt: any): Date | null {
    if (!createdAt) return null;

    if (typeof createdAt.toDate === 'function') {
      return createdAt.toDate();
    }

    if (createdAt instanceof Date) {
      return createdAt;
    }

    if (typeof createdAt === 'string') {
      return new Date(createdAt);
    }

    return null;
  }
}
